export default __webpack_public_path__ + "static/media/myImage.35b0bce8.jpg";